(function () {
  'use strict'

  require('dynamic-bind-html')

  require('./scss/app.scss')
  require('./scss/app-vcard-dynamic.scss')

  const MODULE_NAME = 'thismoment.card.component.appVcardDynamic'
  const templateUrl = require('./tpl/app-vcard-dynamic.html')

  require('angular')
    .module(MODULE_NAME, [
      'dynamicBindHtml',
      require('../../common/component/video')
    ])
    .config(appVcardDynamicConfig)
    .component('thismomentAppVcardDynamic', {
      require: {
        parent: '^thismomentCard'
      },
      bindings: {
        item: '<'
      },
      templateUrl: templateUrl,
      controller: appVcardDynamicController
    })

  appVcardDynamicConfig.$inject = ['$compileProvider']
  function appVcardDynamicConfig ($compileProvider) {
    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|mailto|tel|sms):/)
  }

  appVcardDynamicController.$inject = ['$element', '$timeout', '$window', 'SdkConfig', 'ExpandedContent']
  function appVcardDynamicController ($element, $timeout, $window, SdkConfig, ExpandedContent) {
    const vm = this

    vm.$onInit = vcardDynamicInit
    vm.isMobile = SdkConfig.get('is_mobile')
    vm.expandVideoVcard = expandVideoVcard

    function vcardDynamicInit () {
      // NOTE: Injected variables are reassigned as Angular deals with
      // different things, so we're caching a local copy of our $element
      // for later shenanigans (SEE: setBaseFont, below).
      const element = $element

      vm.trackEvent = vm.parent.trackEvent

      // NOTE: This is here because the vCard font-size needs to be dynamically
      // set to be proportional to the container width.
      $timeout(setBaseFont(), 100)
      angular.element($window).bind('resize', setBaseFont)

      if (angular.isUndefined(vm.item.app.user.vcard)) {
        return
      }

      // prepend w/ string to convert possible int to string
      let phoneNumber = '' + vm.item.app.user.vcard.phone_selected
      phoneNumber = phoneNumber.replace(/\D/g, '')
      phoneNumber = phoneNumber.substr(phoneNumber.length - 10)
      // display phone as (DDD) DDD-DDDD
      vm.displayPhoneNumber = '(' + phoneNumber.substr(0, 3) + ') ' + phoneNumber.substr(3, 3) + '-' + phoneNumber.substr(6, 4)

      const emailParams = {}
      if (vm.item.app.user.vcard.cc_addresses) {
        emailParams.cc = vm.item.app.user.vcard.cc_addresses
      }
      if (vm.item.app.reply_subject) {
        emailParams.subject = vm.item.app.reply_subject
      }
      if (vm.item.app.reply_body) {
        emailParams.body = vm.item.app.reply_body
          .replace('__FIRSTNAME__', vm.item.app.user.vcard.first_name)
          .replace('__EMAIL__', vm.item.app.user.vcard.email)
      }
      vm.mailto = 'mailto:' + vm.item.app.user.vcard.email + '?' + Object.keys(emailParams).map(key => {
        return key + '=' + encodeURIComponent(emailParams[key].replace(/\n/g, '\r\n'))
      }).join('&')

      const queryParams = $window.location.search
      if (queryParams.includes('vcardVideoId')) {
        const contentId = queryParams.substring(queryParams.indexOf('=') + 1)
        if (contentId === vm.item.app.user.vcard.profile_video_content_item.id) {
          expandVideoVcard()
        }
      }

      function setBaseFont () {
        $timeout(() => {
          vm.styles = {
            container: {
              'font-size': Math.floor(element[0].getBoundingClientRect().width * 0.04) + 'px'
            }
          }
        }, 0)
      }
    }

    function expandVideoVcard () {
      const vcardVideo = vm.item.app.user.vcard.profile_video_content_item
      vcardVideo.extended = {}
      ExpandedContent.open(vcardVideo, {
        card_date_display: false,
        card_description_display: false,
        card_share_display: false,
        card_source_display: false,
        card_title_display: false
      })
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/card/component/app-vcardDynamic.js